<template>
  <div class="content">
    <v-card>
      <v-tabs v-model="currentTabIndex" background-color="#e2007a" dark>
        <v-tab v-for="tab in tabs" :key="tab" :value="tab">{{ tab }}</v-tab>
      </v-tabs>
    </v-card>
    <div v-if="currentTabIndex == 1">
      <md-card class="p-4">
        <div class="font-medium text-xl pb-4">Cabinet</div>
        <div class="font-medium pt-2">CLIENT</div>
        <div class="flex flex-col">
          <div class="flex flex-row gap-8">
            <v-select
              class="basis-1/2"
              :items="experts"
              v-model="expert"
              label="Expert"
            ></v-select>
            <v-select
              v-if="cabinets.length > 0"
              class="basis-1/2"
              :items="cabinets"
              v-model="cabinetLabel"
              label="Client"
            ></v-select>
          </div>
        </div>
        <div class="font-medium pt-4">STRUCTURE</div>
        <div class="flex flex-col">
          <div class="flex flex-row gap-8">
            <md-field class="basis-1/4">
              <label>Identifiant de structure</label>
              <md-input required v-model="structure.finessNumber"></md-input>
            </md-field>
            <md-field class="basis-1/4">
              <label>Nom public</label>
              <md-input v-model="structure.publicName"></md-input>
            </md-field>
            <md-field class="basis-1/4">
              <label>Nom légal</label>
              <md-input v-model="structure.legalName"></md-input>
            </md-field>
            <v-select
              class="basis-1/4"
              :items="structure.typeOptions"
              v-model="structure.type"
              label="type"
            ></v-select>
          </div>
          <div class="flex flex-row gap-8">
            <md-field class="basis-1/4">
              <label>Ville</label>
              <md-input v-model="structure.city"></md-input>
            </md-field>
            <md-field class="basis-1/4">
              <label>Code postal</label>
              <md-input v-model="structure.zipCode"></md-input>
            </md-field>
            <md-field class="basis-1/2">
              <label>Adresse</label>
              <md-input v-model="structure.address"></md-input>
            </md-field>
          </div>
        </div>
        <div class="flex flex-row gap-8">
          <md-field>
            <label>Email</label>
            <md-input v-model="structure.email"></md-input>
          </md-field>
          <md-field>
            <label>Numéro de téléphone</label>
            <md-input v-model="structure.phoneNumber"></md-input>
          </md-field>
        </div>

        <div class="font-medium text-xl pb-4">Contractant</div>

        <div class="flex flex-col">
          <div class="flex flex-row gap-8">
            <md-field>
              <label>Email</label>
              <md-input required v-model="contractor.email"></md-input>
            </md-field>
            <md-field>
              <label>Nom</label>
              <md-input required v-model="contractor.lastName"></md-input>
            </md-field>
            <md-field>
              <label>Prénom</label>
              <md-input required v-model="contractor.firstName"></md-input>
            </md-field>
          </div>
          <div class="flex flex-row gap-8">
            <md-field>
              <label>RPPS</label>
              <md-input v-model="contractor.rpps"></md-input>
            </md-field>
            <md-field>
              <label>Spécialité médicale</label>
              <md-input v-model="contractor.medicalSpeciality"></md-input>
            </md-field>
            <md-field>
              <label>Numéro de téléphone</label>
              <md-input required v-model="contractor.phoneNumber"></md-input>
            </md-field>
          </div>

          <div class="font-medium text-xl pb-4">Abonnement</div>
          <div class="flex flex-col">
            <div class="flex flex-row gap-8">
              <md-field>
                <label>Quantité agendas</label>
                <md-input required v-model="quantity"></md-input>
              </md-field>
              <md-datepicker v-model="activationDate">
                <label>Date d'activation</label>
              </md-datepicker>
              <md-datepicker required v-model="expirationDate">
                <label>Date d'expiration</label>
              </md-datepicker>
            </div>
            <div class="flex flex-row gap-8">
              <md-checkbox v-model="teleconsultationEnabled"
                >Activer la téléconsultation</md-checkbox
              >
            </div>
          </div>
          <div class="flex flex-col items-center">
            <md-button
              :disabled="
                structure?.finessNumber == null ||
                contractor?.email == null ||
                contractor?.lastName == null ||
                contractor?.firstName == null ||
                contractor?.phoneNumber == null ||
                Number(quantity) == 0 ||
                activationDate == null ||
                expirationDate == null ||
                cabinetLabel == null
              "
              class="md-prokov"
              @click="submit()"
              >Valider {{ activationStatus }}</md-button
            >
          </div>
        </div>
      </md-card>
    </div>
    <div v-if="currentTabIndex == 0">
      <md-card class="px-4">
        <md-table
          v-model="agendas"
          md-sort="activationDate"
          md-sort-order="asc"
          md-card
        >
          <md-table-row slot="md-table-row" slot-scope="{ item }">
            <md-table-cell
              md-label="Licence MS4 associée"
              md-sort-by="ms4LicenceId"
            >
              {{ item?.ms4LicenceId }}
            </md-table-cell>
            <md-table-cell md-label="Structure ID" md-sort-by="structureId">
              {{ item?.structureId }}
            </md-table-cell>
            <md-table-cell
              md-label="Email contractant"
              md-sort-by="contractorEmail"
            >
              {{ item?.contractorEmail }}
            </md-table-cell>
            <md-table-cell md-label="Quantité" md-sort-by="quantity">
              <md-field v-if="item?.licenceId == editedAgenda?.licenceId">
                <label>Quantité agendas</label>
                <md-input v-model="editedAgenda.quantity"></md-input>
              </md-field>
              <div v-else>
                {{ item?.quantity }}
              </div>
            </md-table-cell>
            <md-table-cell md-label="Téléconsultation">
              <md-checkbox
                v-if="item?.licenceId == editedAgenda?.licenceId"
                v-model="editedAgenda.options.teleconsultation"
              ></md-checkbox>
              <div v-else>
                {{ item?.options?.teleconsultation ? "Oui" : "Non" }}
              </div>
            </md-table-cell>
            <md-table-cell md-label="Activation" md-sort-by="activationDate">
              {{ new Date(item?.activationDate).toLocaleDateString("fr") }}
            </md-table-cell>
            <md-table-cell md-label="Expiration" md-sort-by="expirationDate">
              <md-datepicker
                v-if="item?.licenceId == editedAgenda?.licenceId"
                v-model="editedAgenda.expirationDate"
              >
                <label>Date d'expiration</label>
              </md-datepicker>
              <div v-else>
                {{
                  item.expirationDate
                    ? new Date(item?.expirationDate).toLocaleDateString("fr")
                    : "Abonné"
                }}
              </div>
            </md-table-cell>
            <md-table-cell md-label="Renouvellement auto">
              <md-checkbox
                v-model="item.autoRenewalDoctoDispo"
                @change="toggleAutoRenewal(item)"
                :disabled="updatingLicence === item.licenceId"
              ></md-checkbox>
            </md-table-cell>
            <md-table-cell>
              <div class="flex flex-row gap-6 h-12">
                <div
                  class="flex flex-row gap-4"
                  v-if="item?.licenceId == editedAgenda?.licenceId"
                >
                  <md-button
                    style="width: 10px !important"
                    @click="onEditCancel()"
                  >
                    <md-icon>close</md-icon>
                  </md-button>
                  <md-button
                    style="width: 10px !important"
                    @click="onEditValidate()"
                  >
                    <md-icon>check</md-icon>
                  </md-button>
                </div>
                <md-button
                  v-else
                  style="width: 20px !important"
                  @click="edit(item)"
                >
                  <md-icon>create</md-icon>
                </md-button>
              </div>
            </md-table-cell>
          </md-table-row>
        </md-table>
      </md-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "Agenda",
  data() {
    return {
      currentTabIndex: 0,
      tabs: ["UTILISATEURS", "ACTIVATION"],
      expert: null,
      cabinetLabel: null,
      structureType: "PS",
      structure: {
        finessNumber: null,
        publicName: "",
        legalName: "",
        address: "",
        zipCode: "",
        city: "",
        email: null,
        phoneNumber: "",
        typeOptions: ["PS", "SCM", "SCP", "SISA", "MSP", "CDS"],
        type: "PS",
      },
      contractor: {
        lastName: null,
        firstName: null,
        rpps: null,
        medicalSpeciality: "",
        email: null,
        phoneNumber: null,
        imatAM: 0,
      },
      quantity: 0,
      activationDate: new Date(),
      expirationDate: null,
      teleconsultationEnabled: false,
      editedAgenda: null,
      editedExpirationDate: null,
      editedQuantity: null,
      updatingLicence: null,
    };
  },
  created: function () {
    this.$store.dispatch("agenda/getAgendas");
    this.$store.dispatch("agenda/getExperts");
  },
  computed: {
    activationStatus: {
      get() {
        return this.$store.getters["agenda/getStatus"];
      },
      set(newValue) {},
    },
    experts: {
      get() {
        let list = this.$store.getters["agenda/getExperts"];
        return list.map((v) => v.name);
      },
      set(newValue) {},
    },
    cabinets: {
      get() {
        let list = this.$store.getters["agenda/getCabinets"];
        list = list
          .filter((v) => v.ms4LicenceIds?.length > 0)
          .flatMap((v) =>
            v.ms4LicenceIds.map((l) =>
              this.convertLicenceAndCabinetToDisplayedLabel(l, v.cabinet)
            )
          );
        return list;
      },
      set(newValue) {},
    },
    agendas: {
      get() {
        let list = this.$store.getters["agenda/getAgendas"];
        return list;
      },
      set(newValue) {},
    },
  },
  watch: {
    expert: function (newVal, oldVal) {
      this.$store.dispatch("agenda/getCabinets", newVal);
    },
    agendas: function (newVal, oldVal) {},
    currentTabIndex: function (newVal, oldVal) {
      this.$store.dispatch("agenda/getAgendas");
    },
  },
  methods: {
    edit(value) {
      value.expirationDate = new Date(value.expirationDate);
      this.editedAgenda = { ...value, options: { ...value.options } };
    },
    onEditCancel() {
      this.editedAgenda = null;
    },
    async onEditValidate() {
      const param = {
        licenceId: this.editedAgenda.licenceId,
        quantity: this.editedAgenda.quantity,
        expirationDate: this.editedAgenda.expirationDate,
        options: {
          teleconsultation: this.editedAgenda.options.teleconsultation,
        },
      };
      
      try {
        await this.$store.dispatch("agenda/updateAgenda", param);
        this.editedAgenda = null;
        this.showNotification("success", "Licence mise à jour avec succès");
      } catch (errorInfo) {
        this.showErrorNotification(errorInfo);
      }
    },
    async submit() {
      const param = {
        activationDate: this.activationDate,
        expirationDate: this.expirationDate,
        ms4LicenceId: this.convertDisplayedLabelToLicence(this.cabinetLabel),
        structure: this.structure,
        contractor: this.contractor,
        quantity: this.quantity,
        teleconsultationEnabled: this.teleconsultationEnabled,
      };
      
      try {
        await this.$store.dispatch("agenda/activateAgenda", param);
        this.showNotification("success", "Licence DoctoDispo activée avec succès");
      } catch (errorInfo) {
        this.showErrorNotification(errorInfo);
      }
    },
    showNotification(type, message) {
      this.$notify({
        message: message,
        icon: type === "success" ? "check_circle" : "error",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: type,
        timeout: 5000,
      });
    },
    showErrorNotification(errorInfo) {
      const errorTypeLabels = {
        EQWO_API_ERROR: "Erreur EQWO",
        LICENCE_NOT_FOUND: "Licence introuvable",
        VALIDATION_ERROR: "Erreur de validation",
        MISSING_API_KEY: "Configuration serveur",
        NETWORK_ERROR: "Erreur réseau",
        AUTHENTICATION_ERROR: "Erreur d'authentification",
        INTERNAL_ERROR: "Erreur interne",
        UNKNOWN_ERROR: "Erreur",
      };
      
      const typeLabel = errorTypeLabels[errorInfo.type] || errorInfo.type;
      const message = `${typeLabel}: ${errorInfo.message}`;
      
      this.$notify({
        message: message,
        icon: "error",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: "danger",
        timeout: 7000,
      });
    },
    convertDisplayedLabelToLicence(label) {
      return label.split("(licence : ")[1].slice(0, -1);
    },
    convertLicenceAndCabinetToDisplayedLabel(licence, cabinet) {
      return `${cabinet} (licence : ${licence})`;
    },
    async toggleAutoRenewal(item) {
      try {
        this.updatingLicence = item.licenceId;
        await this.$store.dispatch("agenda/toggleDoctoDispoAutoRenewal", {
          licenceId: item.licenceId,
          autoRenewalDoctoDispo: item.autoRenewalDoctoDispo,
        });
      } catch (error) {
        // Revert the checkbox on error
        item.autoRenewalDoctoDispo = !item.autoRenewalDoctoDispo;
        throw new Error(
          "Erreur lors de la mise à jour du renouvellement automatique:",
          error
        );
      } finally {
        this.updatingLicence = null;
      }
    },
  },
};
</script>
